export default __webpack_public_path__ + "static/media/AnnexHotel-DrinksMenu-DIGITAL-Jan2024.c6d7db92.pdf";